import React, { useEffect, useState } from "react";
import CallAPI from "../utils/call-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faCircleXmark, faEdit, faXmark } from "@fortawesome/free-solid-svg-icons";
import './user.css';
import { Link } from "react-router-dom";
import moment from "moment-timezone";

export default function User() {
  const INIT_USER = {
    name: '',
    phone: '',
    password: '',
    numSessions: 0,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  };
  const [isEdit, setIsEdit] = useState(false);
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(INIT_USER);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await CallAPI.get('/user');
      setUsers(res.data);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleEditClick = (user) => {
    return (evt) => {
      setIsEdit(true);
      setEditingUser(user);
    };
  };

  const handleChange = (evt) => {
    setEditingUser(prev => ({
      ...prev,
      [evt.target.name]: evt.target.value,
    }));
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    let res;
    if (editingUser._id) {
      res = await CallAPI.put(`/user/${editingUser._id}`, editingUser);
    } else {
      res = await CallAPI.post('/user/', editingUser);
    }
    const i = users.findIndex(u => u._id === res.data._id);
    if (i === -1) {
      users.push(res.data);
    } else {
      users.splice(i, 1, res.data);
    }
    setUsers([ ...users ]);
    setIsEdit(false);
  };

  const handleAddClick = (evt) => {
    setIsEdit(true);
    setEditingUser(INIT_USER);
  };

  const handleDeleteClick = (user) => {
    return async (evt) => {
      if (!window.confirm(`ต้องการลบผู้ใช้\n${user.name} ${user.phone}`)) {
        return;
      }
      const res = await CallAPI.delete(`/user/${user._id}`);
      const i = users.findIndex(u => u._id === res.data._id);
      users.splice(i, 1);
      setUsers([ ...users ]);
    };
  };

  return (
    <>
    <div><button className="btn-add" onClick={handleAddClick}><FontAwesomeIcon icon={faAdd}/> เพิ่ม</button></div>
    {loading ?
      <div>loading</div>
      :
      <table className="list-user">
        <thead>
          <tr>
            <th>ชื่อ</th>
            <th>เบอร์โทร</th>
            <th>รหัสผ่าน</th>
            <th>คลาส</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user._id}>
              <td>
              {!user.isAdmin ? 
                <Link to={`/user/${user._id}`}>{user.name}</Link>
                :
                <>{user.name}</>
              }
              </td>
              <td>{user.phone}</td>
              <td>{user.password}</td>
              <td>{user.numSessions}</td>
              <td>
                <button className="as-a" onClick={handleEditClick(user)}><FontAwesomeIcon icon={faEdit}/></button>
                {!user.isAdmin && <button className="as-a" onClick={handleDeleteClick(user)}><FontAwesomeIcon icon={faCircleXmark}/></button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    }

    {isEdit ?
      <div className="modal">
        <div className="container">
          <div className="header"><button className="as-a btn-close" onClick={() => setIsEdit(false)}><FontAwesomeIcon icon={faXmark}/></button></div>
          <div className="content">
            <form onSubmit={handleSubmit}>
              <div><input type="text" name="name" placeholder="ชื่อ" value={editingUser.name} onChange={handleChange}/></div>
              <div><input type="text" name="phone" placeholder="เบอร์โทร" maxLength="10" value={editingUser.phone} onChange={handleChange}/></div>
              <div><input type="text" name="password" placeholder="รหัสผ่าน" value={editingUser.password} onChange={handleChange}/></div>
              <div><input type="number" name="numSessions" placeholder="คลาส" value={editingUser.numSessions} onChange={handleChange}/></div>
              <div><input type="date" name="startDate" placeholder="เริ่มวันที่" value={moment(editingUser.startDate).format('YYYY-MM-DD')} onChange={handleChange}/></div>
              <div><input type="date" name="endDate" placeholder="สิ้นสุดวันที่" value={moment(editingUser.endDate).format('YYYY-MM-DD')} onChange={handleChange}/></div>
              <div><button type="submit">บันทึก</button></div>
            </form>
          </div>
        </div>
      </div>
    : ''}
    </>
  );
}
